import { createAsyncThunk } from '@reduxjs/toolkit'

import { IUserTicketData } from 'meta/pages/v4/ticket'
import { TicketController } from 'controller/ticket'

type Returned = IUserTicketData

type Props = {
  cod: string
}

export const getData = createAsyncThunk<Returned, Props>('pages/ticket/data', async (props) => {
  const { cod } = props

  return TicketController.getData({ cod })
})
